export default {
	row: {
		marginBottom: 0,
	},
	paperVoucher: {
		margin: '20px 0',
	},
	subTitle: {
		marginTop: 5,
		marginBottom: 0,
	},
	buttonVoucherContainer: {
		margin: '14px 0 20px 0',
		textAlign: 'right',
	},

	voucherBalanceRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: '10px',
	},
	voucherBalanceLabel: {
		fontWeight: 'bold',
	},
	voucherHelpText: {
		marginTop: 2,
		lineHeight: 1,
		fontWeight: '200',
		fontStyle: 'italic',
	},
	voucherHelpTextContainer: {
		backgroundColor: '#E5E5E5',
		padding: '10px',
		borderTop: '1px solid #E0E0E0',
		borderBottom: '1px solid #E0E0E0',
	},
	pciHelperText: {
		marginTop: 7,
		lineHeight: 1,
		fontWeight: '200',
		fontStyle: 'italic',
	},
	buttonPciTelecom: {
		marginTop: '14px',
	},
};
